import { JobSearchInfo } from './JobSearchInfo'
export default JobSearchInfo
